var path = 'match-history/match-history.html';
var html = "<div class=\"ns-grid ns-grid--fluid-hugged\">\n   <div class=\"ns-grid__row\">\n      <div class=\"ns-grid__col--lg-8\">\n         <h1>Clever Import History</h1>\n         <p>Here is your history of all Clever import activity.</p>\n      </div>\n      <div class=\"ns-grid__col--lg-4\">\n         <a ng-href=\"{{vm.getLandingUrl()}}\">Go back to current Clever imports</a>\n      </div>\n   </div>\n   <ns-table rows=\"vm.history\" columns=\"vm.columns\" row-height=\"7\" header-height=\"1\"></ns-table>\n   <div class=\"ns-grid__col--lg-12 zero-history-message\" ng-if=\"vm.noHistoryMessage()\">There is no match history at this time.</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/match-history/match-history.html
// module id = 29
// module chunks = 0